import './leaveApproval.css';
import { useEffect, useState } from "react";
import { leaveAPI } from '../../api/leaveAPI';
import UserPcode from '../../components/userPcode';
import Department from '../../components/department';
import Spinner from '../../components/spinner';

const findBalance = (leaves, keyword) => {
    const match = leaves.find((l) => l.leaveTypeName?.toLowerCase().includes(keyword));
    return match ? match.balanceLeaves : '-';
}

export default function EmployeeLeaveBalance() {
    const [isProcessing, setIsProcessing] = useState(false);

    const [selectedPcode, setSelectedPcode] = useState('');
    const [selectedDepartment, setSelectedDepartment] = useState('');
    const [employees, setEmployees] = useState([]);
    const [searchKeyword, setSearchKeyword] = useState('');

    useEffect(() => {
        if (selectedPcode.trim().length === 0) { setEmployees([]); return; }

        setIsProcessing(true);

        leaveAPI.getAllEmployeeLeaveBalances(selectedPcode, selectedDepartment).
            then((data) => setEmployees(data)).
            finally(() => setIsProcessing(false));
    }, [selectedPcode, selectedDepartment])

    const filteredEmployees = employees.filter((emp) => {
        const keyword = searchKeyword.trim().toLowerCase();
        if (keyword.length === 0) return true;
        return emp.empCode?.toLowerCase().includes(keyword) || emp.employeeName?.toLowerCase().includes(keyword);
    });

    return (
        <div className="row">
            <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 p-2 rounded contentLeveApproval form__body">
                <div className="row mt-1">
                    <div className="col-12 text-center">
                        <h4>Employee Leave Balance</h4>
                    </div>
                </div>

                <div className="row mt-2">
                    <div className='col-0 col-sm-0 col-md-3 col-lg-3 col-xl-3 col-xxl-3'></div>
                    <div className="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6 col-xxl-6">
                        <div className="input-group input-group-sm">
                            <UserPcode setSelectedPcode={setSelectedPcode} />
                        </div>
                    </div>
                    <div className='col-0 col-sm-0 col-md-3 col-lg-3 col-xl-3 col-xxl-3'></div>
                </div>

                <div className="row mt-2">
                    <div className='col-0 col-sm-0 col-md-3 col-lg-3 col-xl-3 col-xxl-3'></div>
                    <div className="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6 col-xxl-6">
                        <div className="input-group input-group-sm">
                            <Department
                                pcode={selectedPcode}
                                selectedDepartment={selectedDepartment}
                                setSelectedDepartment={setSelectedDepartment}
                            />
                        </div>
                    </div>
                    <div className='col-0 col-sm-0 col-md-3 col-lg-3 col-xl-3 col-xxl-3'></div>
                </div>

                <div className="row mt-2">
                    <div className='col-0 col-sm-0 col-md-3 col-lg-3 col-xl-3 col-xxl-3'></div>
                    <div className="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6 col-xxl-6">
                        <input
                            type="text"
                            className="form-control form-control-sm"
                            placeholder="Search by Emp Code or Name"
                            value={searchKeyword}
                            onChange={(e) => setSearchKeyword(e.target.value)}
                        />
                    </div>
                    <div className='col-0 col-sm-0 col-md-3 col-lg-3 col-xl-3 col-xxl-3'></div>
                </div>

                <div className='row'>
                    <div className='col-12 mt-2'>
                        {
                            isProcessing === true ?
                                <div className="text-center"><Spinner /></div>
                                :
                                <table className="table text-nowrap table-responsive-sm table-responsive-md table">
                                    <thead>
                                        <tr>
                                            <th>#</th>
                                            <th>Emp Code</th>
                                            <th>Name</th>
                                            <th>Casual</th>
                                            <th>Annual</th>
                                            <th>Medical</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            filteredEmployees.map((emp, index) => (
                                                <tr key={emp.empCode}>
                                                    <td>{index + 1}</td>
                                                    <td>{emp.empCode}</td>
                                                    <td>{emp.employeeName}</td>
                                                    <td>{findBalance(emp.leaves, 'casual')}</td>
                                                    <td>{findBalance(emp.leaves, 'annual')}</td>
                                                    <td>{findBalance(emp.leaves, 'medical')}</td>
                                                </tr>
                                            ))
                                        }
                                    </tbody>
                                </table>
                        }
                    </div>
                </div>
            </div>
        </div>
    );
}
